"use client";

import Link from "next/link";
import { useContent } from "../../content/current";

export default function LegalNav() {
  const content = useContent();
  return (
    <nav id="footernav">
      <ul>
        <li className="link">
          <Link href="/politica-de-privacidad" prefetch={false}>{content.nav.privacy}</Link>
        </li>
        <li className="link">
          <Link href="/aviso-legal" prefetch={false}>{content.nav.legal}</Link>
        </li>
        <li className="link">
          <Link href="/politica-de-cookies" prefetch={false}>{content.nav.cookies}</Link>
        </li>
      </ul>
    </nav>
  );
}
